import { Component, Prop } from 'vue-property-decorator'

import { Mixins } from 'vue-mixin-decorator'
import MixinInterface from '@/_mixins/index'
import GeneralMixin from '@/_mixins/general'

@Component({
    mixins: [GeneralMixin],
})
export default class CalendarPicker extends Mixins<MixinInterface>(GeneralMixin) {
    @Prop({ default: null }) start!: string
    @Prop({ default: null }) end!: string
    @Prop({ default: null }) period!: string

    @Prop() timeZone!: string
    @Prop() min!: string
    @Prop() max!: string

    created() {
        this.inputStart = this.start
        this.inputEnd = this.end
        this.inputPeriod = this.period
    }
    type = 'start'
    picker = new Date().toISOString().substr(0, 10)
    inputStart: any = null
    inputEnd: any = null
    inputPeriod: any = null

    setPeriodDate(day: number) {
        if (day) {
            this.inputStart = this.generalFormat(
                new Date(Date.now() - 86400 * 1000 * day),
                this.timeZone
            )
            this.inputEnd = this.generalFormat(new Date(), this.timeZone)
            this.inputPeriod = day
        } else {
            this.inputStart = null
            this.inputEnd = null
            this.inputPeriod = null
        }
    }

    setCalendarDate(data: any) {
        if (this.type == 'start') {
            this.inputStart = data
                ? this.formatDateTimeWithTimeZone(data, '00:00', this.timeZone)
                : null
        } else {
            this.inputEnd = data
                ? this.formatDateTimeWithTimeZone(data, '23:59', this.timeZone)
                : null
        }
        this.inputPeriod = null
    }

    validateDate(date: string) {
        let valid = this.generateDate(date, 'DD.MM.YYYY') ? true : false
        return valid
    }

    close() {
        this.$emit('close')
    }

    save() {
        this.$emit('data', { ge: this.inputStart, le: this.inputEnd, period: this.inputPeriod })
        this.close()
    }
}
